import type { QueryClient } from "@tanstack/react-query";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { MainLayout } from "@/components/organisms/Layout/MainLayout";
import { routePaths } from "@/config/route-paths";
import { RequireRole } from "@/features/auth";
import { handleDynamicImportError } from "@/lib/react-router";
import { convert } from "@/lib/react-router-convert";

export const ConnectSettingsRoutes: (
  queryClient: QueryClient
) => RouteObject[] = (queryClient: QueryClient) => [
  {
    element: <MainLayout isExpand />,
    children: [
      {
        path: routePaths.tenants.root.path,
        lazy: () =>
          import("./layout").then(convert(queryClient)).catch((error) =>
            handleDynamicImportError({
              componentName: "connect-settings/layout",
              error,
            })
          ),
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={routePaths.tenants.imageLibrary.relativePath}
                replace={true}
              />
            ),
          },
          {
            // 作業領域。ロールによる差はなく、所属テナントかどうかだけを見る
            element: <RequireRole allow={["host", "admin", "member"]} />,
            children: [
              {
                path: routePaths.tenants.imageLibrary.relativePath,
                lazy: () =>
                  import("./image-library-route")
                    .then((m) => ({ default: m.ImageLibraryRoute }))
                    .then(convert(queryClient))
                    .catch((error) =>
                      handleDynamicImportError({
                        componentName:
                          "connect-settings/routes/image-library-route",
                        error,
                      })
                    ),
              },
              // レポートライブラリは機能を公開しないためルートを登録しない。
              // 直リンクは 404 になる。公開するときは tenant-navigation.tsx の
              // 導線と合わせて戻す
              // {
              //   path: routePaths.tenants.reportLibrary.relativePath,
              //   lazy: () =>
              //     import("./report-library-route")
              //       .then((m) => ({ default: m.ReportLibraryRoute }))
              //       .then(convert(queryClient))
              //       .catch((error) =>
              //         handleDynamicImportError({
              //           componentName:
              //             "connect-settings/routes/report-library-route",
              //           error,
              //         })
              //       ),
              // },
            ],
          },
          {
            // 管理領域。作業画面と違い、ホストと管理者だけが入れる
            path: routePaths.tenants.manage.root.relativePath,
            element: <RequireRole allow={["host", "admin"]} />,
            children: [
              {
                path: routePaths.tenants.manage.users.relativePath,
                lazy: () =>
                  import("@/features/user-management/routes/user-list-route")
                    .then((m) => ({ default: m.UserListRoute }))
                    .then(convert(queryClient))
                    .catch((error) =>
                      handleDynamicImportError({
                        componentName: "user-management/routes/user-list-route",
                        error,
                      })
                    ),
              },
            ],
          },
        ],
      },
    ],
  },
];
